<template lang="pug">
div(class="xl12 l12 m12 s12 insety-16 border-bottom")
    div(class="before-8")
        label(class="bold bond-title fg70") {{ $t('coupon_rate') }}
    div(class="xl12 l12 m12 s12 flex-flex after-16")
        div(class="matdate cr-date")
            label(class="fg50 fs7 insety-8") {{ $t('minimum') }}
            ib-field(name="amount_min_range2", class="outset-0 inset-8", :min="0", :max="11", width="15ch",
                placeholder="0", type="text", :step="0.1", v-model="rates[0]", :maxlength="5", @input="minMaxCoupon", @change="getRates")
                span %
        div(class="matdate cr-date")
            label(class="fg50 fs7 insety-8") {{ $t('maximum') }}
            ib-field(name="amount_max_range2", class="outset-0 inset-8", :min="0", :max="11", width="15ch",
                placeholder="100", type="text", :step="0.1", v-model="rates[1]", :maxlength="5", @input="minMaxCoupon", @change="getRates")
                span %
    ib-slider(class="slide-container", style="width:95%;" :min="0", :max="100", :step=".01", range, v-model="rates", @change="minMaxCoupon")
        div(:style="{ width:'100%',height:'24px', background:'#eee' }")
</template>

<script>
    import mxGb from '../mixin/mixin-global'
    export default {
        name: 'CouponRate',

        data() {
            return {
                rates: ['','']
            }
        },

        mixins: [ mxGb ],

        mounted() {
            this.$nextTick(() => {
                if (this.subFilters) {
                    const minRate = this.getFilterValue('couponRateAbove');
                    const maxRate = this.getFilterValue('couponRateBelow');
                    this.rates = [ minRate, maxRate ];
                    this.minMaxCoupon();
                }
            });
        },

        methods: {
            minMaxCoupon() {
                const cp0 = parseFloat(this.rates[0]);
                const cp1 = parseFloat(this.rates[1]);
                const nums = /^[0-9]+(.[0-9]{1,2})?$/;
                if (this.rates[0] < 0) {
                    this.$alert(this.$t('min_value_alert'));
                    this.rates = ['',''];
                }
                if (this.rates[0] > 100) {
                    this.$alert(this.$t('min_100_alert'));
                    this.rates = ['',''];
                }
                if (this.rates[1] > 100) {
                    this.$alert(this.$t('max_value_alert'));
                    this.rates = ['',''];
                }
                if (this.rates[1] < 0) {
                    this.$alert(this.$t('max_0_alert'));
                    this.rates = ['',''];
                }
                if (cp0 && !nums.test(cp0)) {
                    this.$alert(this.$t('two_decimal_places'));
                    this.rates = ['',''];
                }
                if (cp1 && !nums.test(cp1)) {
                    this.$alert(this.$t('two_decimal_places'));
                    this.rates = ['',''];
                }
                this.$emit('minMaxCoupon', this.rates);
                this.getRates();
            },
            getRates() {
                this.$emit('getRates');
            },
            reset() {
                this.rates = ['', ''];
            }
        }
    }
</script>

<style lang="less">
@media (max-width: 450px) {
    .matdate {
        &.cr-date {
            max-width: 45%;
        }
    }
}
</style>
